export const MASKS: any[] = [
    {   
        'label': 'Belgium in circle',
        'type': 'mask',
        'maskType': 'circle',
        'projection': 'EPSG:4326',
        'coords' : {
            'center': [4.67, 50.64],
            'radius': 160
        }
    },
    {   
        'label': 'Test polygon',
        'type': 'mask',
        'maskType': 'shape',
        'projection': 'EPSG:4326',
        'coords': [[3.5, 50.5], [4.5, 50.3], [5.5, 50.5], [5.5, 51], [4.5, 51.2], [3.5, 51], [3.5, 50.5]]
    },
    {
        'label': 'Test circle',
        'type': 'mask',
        'maskType': 'circle',
        'projection': 'EPSG:4326',
        'coords' : {
            'center': [4.392, 50.845],
            'radius': 50
        }  
    }
]
